// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__sqZBd","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2Wp8U"};